import { getBaseUrl } from './razorpay';

async function getAffinityUserDetails(params, fetchInActive = true) {
    const queryParts = ['fetchInActive=' + fetchInActive];
    if (typeof params === 'object') {
        if (params.mobilenumber) queryParts.push('mobilenumber=' + encodeURIComponent(params.mobilenumber));
        if (params.subscriptionId) queryParts.push('subscriptionId=' + encodeURIComponent(params.subscriptionId));
        if (params.id) queryParts.push('id=' + encodeURIComponent(params.id));
    } else {
        queryParts.push('id=' + params);
    }
    const url = getBaseUrl() + '/patientswebapp/affinity/getAffinityUserDetails?' + queryParts.join('&');
    const response = await fetch(url);
    return response.json();
}

function parseDob(dobStr) {
    if (!dobStr) return null;
    const parts = dobStr.split('-');
    if (parts.length === 3) {
        return `${parts[2]}-${parts[1]}-${parts[0]}`;
    }
    const slashParts = dobStr.split('/');
    if (slashParts.length === 3) {
        return `${slashParts[2]}-${slashParts[1]}-${slashParts[0]}`;
    }
    return dobStr;
}

function mapRenewalDataToFormData(userData) {
    if (!userData) return null;

    const prefillData = {
        name: (userData.proposer_name || '').replace(/\./g, ' '),
        email: userData.email || '',
        mobile: userData.mobilenumber || '',
        dob: parseDob(userData.proposer_dob),
        gender: userData.gender || '',
        Address: userData.address || '',
        city: userData.city || '',
        state: userData.state || '',
        pincode: userData.pincode || '',
        referralCode: userData.referralCode || '',
    };

    if (userData.extraInfo) {
        let extraInfo = userData.extraInfo;
        if (typeof extraInfo === 'string') {
            try { extraInfo = JSON.parse(extraInfo); } catch (e) { extraInfo = {}; }
        }
        if (extraInfo.employeeCode) prefillData.employeeCode = extraInfo.employeeCode;
        if (extraInfo.branchType) prefillData.branchType = extraInfo.branchType;
        if (extraInfo.branchCode) prefillData.branchCode = extraInfo.branchCode;
        if (extraInfo.partnerBranchCode) prefillData.branchCode = extraInfo.partnerBranchCode;
    }

    if (userData.nomineeDetails) {
        let nominee = userData.nomineeDetails;
        if (typeof nominee === 'string') {
            try { nominee = JSON.parse(nominee); } catch (e) { nominee = {}; }
        }
        if (nominee.name) prefillData.nomineeName = nominee.name;
        if (nominee.relation) prefillData.nomineeRelation = nominee.relation;
        if (nominee.dob) prefillData.nomineeDob = nominee.dob;
    }

    if (userData.additionalMemberData) {
        let members = userData.additionalMemberData;
        if (typeof members === 'string') {
            try { members = JSON.parse(members); } catch (e) { members = {}; }
        }
        Object.keys(members).forEach(key => {
            if (key === 'metaData') return;
            const match = key.match(/^additionalMember(\d+)$/);
            if (!match) return;
            const memberIndex = parseInt(match[1]) + 1;
            const member = members[key];
            if (typeof member === 'string') {
                prefillData[`member_name${memberIndex}`] = member;
            } else if (member && typeof member === 'object') {
                if (member.name) prefillData[`member_name${memberIndex}`] = member.name;
                if (member.email) prefillData[`member_email${memberIndex}`] = member.email;
                if (member.mobile) prefillData[`member_mobile${memberIndex}`] = member.mobile;
                if (member.gender) prefillData[`member_gender${memberIndex}`] = member.gender;
                if (member.relationship) prefillData[`member_relationship${memberIndex}`] = member.relationship;
                if (member.dob) prefillData[`member_dob${memberIndex}`] = parseDob(member.dob);
            }
        });
    }

    return {
        prefillData,
        packageId: userData.packageId || null,
        renewalId: userData.id || null
    };
}

export { getAffinityUserDetails, mapRenewalDataToFormData, parseDob };
